import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/Home.vue';
import AuthCallback from '@/AuthCallback.vue';
import AdministrationView from '@/admin/AdministrationView.vue';
import GroupMembers from '@/admin/GroupMembers.vue';
import GroupPermissions from '@/admin/GroupPermissions.vue';
import GroupStats from '@/admin/GroupStats.vue';
import PaperDatabase from '@/admin/PaperDatabase.vue';
import FluteDatabase from '@/admin/FluteDatabase.vue';
import BoxDatabase from '@/admin/BoxDatabase.vue';
import FoodSafetyAndCarbonFootprint from '@/admin/FoodSafetyAndCarbonFootprint.vue';
import ProjectDownload from '@/admin/ProjectDownload.vue';

import GroupOrUser from '@/GroupOrUser.vue';
import Project from '@/Project.vue';
import CreateProject from '@/CreateProject.vue';
import SignedOut from '@/SignedOut.vue';
import Error404 from '@/Error404.vue';
// import store from './store';
// import { auth } from './auth/AuthService';
import store from './store';

Vue.use(VueRouter);

const router = new VueRouter({
  /*
   * NOTE! VueRouter "history" mode DOESN'T works for Cordova builds,
   * it is only to be used only for websites.
   *
   * If you decide to go with "history" mode, please also open /config/index.js
   * and set "build.publicPath" to something other than an empty string.
   * Example: '/' instead of current ''
   *
   * If switching back to default "hash" mode, don't forget to set the
   * build publicPath back to '' so Cordova builds work again.
   */

  // https://router.vuejs.org/en/essentials/history-mode.html
  mode: 'history',

  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      // beforeEnter: () => {
      //   if (!auth.isAuthenticated()) {
      //     auth.login();
      //   }
      // },
    },
    {
      path: '/projects/new',
      name: 'CreateProject',
      component: CreateProject,
    },
    {
      path: '/auth-callback',
      name: 'AuthCallback',
      component: AuthCallback,
    },
    {
      path: '/signed-out',
      name: 'SignedOut',
      component: SignedOut,
    },
    {
      path: '/admin',
      component: AdministrationView,
      children: [
        {
          path: '/',
          name: 'Admin',
          redirect: 'group-members',
        },
        {
          path: 'group-members',
          component: GroupMembers,
        },
        {
          path: 'group-permissions',
          component: GroupPermissions,
        },
        {
          path: 'group-stats',
          component: GroupStats,
        },
        {
          path: 'paper-database',
          component: PaperDatabase,
        },
        {
          path: 'flute-database',
          component: FluteDatabase,
        },
        {
          path: 'box-database',
          component: BoxDatabase,
        },
        {
          path: 'food-and-carbon',
          component: FoodSafetyAndCarbonFootprint,
        },
        {
          path: 'project-download',
          component: ProjectDownload,
        },

      ],
    },
    {
      path: '/:groupOrUser',
      name: 'GroupOrUser',
      component: GroupOrUser,
    },
    {
      path: '/:group/:project/',
      name: 'Project',
      component: Project,
    },
    {
      path: '*',
      name: 'Error404',
      component: Error404,
    },
  ],
});

router.beforeEach((to, from, next) => {
  store.commit('setError', null);
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router.ts